import { SimplePaymentPage } from 'modules/PaymentsApp/components/SimplePaymentPage'
import { IconExclamationTriangle } from '@sequencehq/core-components'

export const NotReady = () => {
  return (
    <SimplePaymentPage
      icon={IconExclamationTriangle}
      iconColour="gray.70"
      header="Invoice not ready yet"
      subheader={'This invoice is not ready for payment yet'}
      nextSteps={[
        'Please finalize and send the invoice to make payment available.'
      ]}
    />
  )
}
